module.exports = __webpack_public_path__ + "img/PS39.e4e6a636.png";